import { render } from "./SessionSchedule.vue?vue&type=template&id=825e10ca"
import script from "./SessionSchedule.vue?vue&type=script&lang=js"
export * from "./SessionSchedule.vue?vue&type=script&lang=js"

import "./SessionSchedule.vue?vue&type=style&index=0&id=825e10ca&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__